module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "solutions"
  }, [_c('div', {
    staticClass: "our-solutions",
    attrs: {
      "id": "our-solutions"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "solution-heading"
  }, [_vm._v("Explore Solutions")]), _vm._v(" "), _c('div', {
    staticClass: "-wrapper"
  }, _vm._l((_vm.List), function(solution) {
    return _c('a', {
      staticClass: "-item",
      attrs: {
        "href": solution.link
      },
      on: {
        "click": function($event) {
          return _vm.solutionClickEvent(solution.name)
        }
      }
    }, [_c('i', {
      class: ("icon " + (solution.iconClass)),
      domProps: {
        "innerHTML": _vm._s(solution.icon)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "solution-name"
    }, [_vm._v(_vm._s(solution.name))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a127b23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/site/Solutions/Solutions.vue
// module id = 457
// module chunks = 0